var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip uk-icon-info-circle",style:(_vm.iconStyle)},[_c('div',{staticClass:"uk-tooltip uk-tooltip-bottom",style:(_vm.style)},[_c('div',{staticClass:"uk-tooltip-inner"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }